export default __webpack_public_path__ + "static/giftlist@2x-25251312cb5de81e923de2c5a67c636e.png";